import React from 'react';
import { dossierSections } from '../data/dossierSections';
interface CaseIndexStripProps {
  activeId: string;
}
export function CaseIndexStrip({
  activeId
}: CaseIndexStripProps) {
  return <nav aria-label="Índice del expediente" className="fixed inset-x-0 top-[44px] z-40 border-b border-gold/20 bg-panel/95 backdrop-blur-md lg:hidden" data-id="element-133" data-mp="1rpw0992jrz0d">
      <ul className="flex gap-1.5 overflow-x-auto px-4 py-1.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-134" data-mp="1nlxzyv1hki5q">
        {dossierSections.map(section => {
        const isActive = activeId === section.id;
        return <li key={section.id} className="flex-shrink-0" data-id="element-135" data-mp="18qrse3mqsbaa">
              <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className={`flex items-center gap-1.5 rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-[0.1em] transition-colors ${isActive ? 'border-gold/60 bg-gold/10 text-gold' : 'border-white/10 text-ash'}`} data-id="element-136" data-mp="18sco3wksm09q">
                <span data-id="element-137" data-mp="1v7wb4ue9vnd0">{section.number}</span>
                <span className="normal-case tracking-normal" data-id="element-138" data-mp="1v6l32idsntg3">
                  {section.label}
                </span>
              </a>
            </li>;
      })}
      </ul>
    </nav>;
}